import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/login.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "[logo]",
  height: "32"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "ml-2 secondary--text"
}
const _hoisted_3 = {
  key: 1,
  class: "ml-2 secondary--text"
}
const _hoisted_4 = {
  key: 1,
  style: {"color":"white"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "[login]",
  height: "32"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: "mx-auto",
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar, {
            density: "compact",
            elevation: 4,
            color: "primary",
            dark: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_app_bar_title, {
                class: "align-center",
                colo: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  (_ctx.$vuetify.display.xl || _ctx.$vuetify.display.lg)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "There Is Always a Movie, Ain't There"))
                    : (!_ctx.$vuetify.display.xs)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "TIAMAT "))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (!_ctx.$vuetify.display.xs)
                ? (_openBlock(), _createBlock(_component_v_tabs, {
                    key: 0,
                    color: "teal-lighten-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, { to: "/" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Movie Lineup")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, { to: "/submit" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Submit Movie")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, { to: "/archive" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Past Movies")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              (_ctx.apiClient.isLoggedIn())
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$vuetify.display.xs ? "" : "Logged in as") + " " + _toDisplayString(_ctx.apiClient.userName), 1))
                : _createCommentVNode("", true),
              (_ctx.$vuetify.display.xs)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    icon: "",
                    onClick: _ctx.logout
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    to: "/login",
                    onClick: _ctx.logout
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.apiClient.userName ? "Change User" : "Login"), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }),
          (_ctx.$vuetify.display.xs)
            ? (_openBlock(), _createBlock(_component_v_bottom_navigation, {
                key: 0,
                fixed: "",
                app: "",
                color: "primary",
                grow: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, { to: "/" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-movie-open" }),
                      _createTextVNode(" Lineup ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, { to: "/submit" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-movie-open-plus" }),
                      _createTextVNode(" Submit ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, { to: "/archive" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-history" }),
                      _createTextVNode(" Past ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}